import React from 'react';
import { useIntl } from 'react-intl';
import type { Organizer } from '@/types';
import { OrganizerAvatar } from '@/components/OrganizerCard/OrganizerData/OrganizerAvatar/OrganizerAvatar';
import { FollowButton, FollowButtonVariant } from '@/components/_shared/buttons/FollowButton/FollowButton';
import styles from './OrganizerInfo.module.scss';
import { LISTING_HEAP_PAGE_AREA_IDS } from '@/components/_shared/constants';

type OrganizerInfoProps = {
  organizer?: Organizer;
};

export const OrganizerInfo: React.FC<OrganizerInfoProps> = ({ organizer }) => {
  const { formatMessage } = useIntl();

  if (!organizer || !organizer.name) {
    return;
  }

  return (
    <div className={styles.wrapper} data-testid="organizer-info">
      <div className={styles.organizerInfoContent}>
        <div className={styles.organizerAvatarWrapper}>
          <OrganizerAvatar organizer={organizer} size="small" />
        </div>
        <span className={styles.byTag}>
          {formatMessage({ id: 'By', defaultMessage: 'By', description: 'By tag for organizer info' })}
        </span>
        <a className={styles.organizerName} href="#organizer-card">
          {organizer.name}
        </a>
      </div>
      <div className={styles.followButtonWrapper}>
        <FollowButton
          organizer={organizer}
          variant={FollowButtonVariant.Organizer}
          pageArea={LISTING_HEAP_PAGE_AREA_IDS.SIMPLIFIED_ORGANIZER}
        />
      </div>
    </div>
  );
};
